import * as types from 'constants/notificarPartidosTypes';
import * as services from 'services/notificarPartido.service';

export const enviarNotificacionPartidos = (dataload) => async (dispatch) => {
  dispatch({ type: types.GET_NOTIFICAR_A_PARTIDO_LOADING });
  try {
    const { data } = await services.notifyPartidos(dataload);
    const payload = data;
    dispatch({ type: types.GET_NOTIFICAR_A_PARTIDO_SUCCESS, payload });
    return { success: true, response: payload };
  } catch (error) {
    dispatch({ type: types.GET_NOTIFICAR_A_PARTIDO_FAILURE, error });
    return { success: false, response: { causa: error.causa, code: error.code } };
  }
};
